/* =============================================
   FOREST ART & FRAME - RUNTIME HELPERS (Shopify port)

   Source: 04_Build_StaticSite/js/config.js, the runtime helper half.
   The configuration half is emitted by snippets/ff-config.liquid, because it
   comes from theme settings and a .js asset cannot run Liquid.

   WHAT CHANGED AND WHY

   The static helpers all had the same shape: "if Shopify is not connected,
   fall back to the demo". On a real theme Shopify is always connected, so each
   helper now returns the real answer and the demo branch is gone.

     FAF.isLive()        was a feature flag gate. Everything it gated is native
                         now, so it returns true and is kept only so that any
                         page script still calling it keeps working.
     FAF.checkoutUrl()   was building a cross domain permalink to an external
                         store. The theme is the store, so it is the local
                         cart permalink.
     FAF.tradeLoginUrl() returned null to trigger a fake login toggle. It now
                         returns the real customer account login route.
     FAF.bookingUrl()    unchanged in spirit, now reading the theme setting.

   Kept as a global on purpose. trade.html and booking.html call FAF_CONFIG and
   FAF directly from inline scripts, and those scripts came across verbatim so
   the approved behaviour is preserved.
   ============================================= */

(function () {
  'use strict';

  var CONFIG = window.FAF_CONFIG || { contact: {}, routes: {} };

  var FAF = {
    /* Everything the old flags gated is native on Shopify. Kept so that any
       surviving caller does not throw. */
    isLive: function () {
      return true;
    },

    /* A cart permalink on this store. variantId is the numeric variant id. */
    checkoutUrl: function (variantId, quantity) {
      var qty = quantity || 1;
      if (!variantId) return CONFIG.routes.cart || '/cart';
      return '/cart/' + variantId + ':' + qty;
    },

    /* Real customer accounts. The static build had no login, so this used to
       return null and the page faked a logged in state. */
    tradeLoginUrl: function () {
      return CONFIG.routes.accountLogin || '/account/login';
    },

    bookingUrl: function () {
      return CONFIG.contact.bookingUrl || CONFIG.routes.booking || '/pages/book-a-consultation';
    },

    shopUrl: function () {
      return CONFIG.routes.shop || '/collections/all';
    },
  };

  window.FAF = FAF;
})();
